import { useEffect, useState } from "react";
import { Container, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import Dropzone from "react-dropzone";
import { AuthHelper } from "../../controllers/AuthHelper";
import { config, S3 } from "aws-sdk";
import { ServerConfig } from "../../../connectors/Config";
import dayjs from "dayjs";
import { Buffer } from "buffer";
import { LoadingButton } from "@mui/lab";
import { SketchPicker } from "react-color";
import { useBuilder } from "../../../hooks/useBuilder";
import store, { clear } from "../../store/formStore";
import { useSelector } from "react-redux";

const Settings = () => {
  const [loading, setLoading] = useState(false);
  const { builder } = useBuilder();
  const elements = useSelector((state) => state.elements);

  const [centro, setCentro] = useState({
    logo_top: "",
    image_bottom: "",
    color: "#000000",
    capitaneria: "",
  });

  useEffect(() => {
    getSchool();
    store.dispatch(clear());
    builder("certificates.add");
  }, []);

  const fileConverterBase64 = (file) => {
    return new Promise((res, rej) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => res(reader.result);
      reader.onerror = (err) => rej(err);
    });
  };

  const getSchool = async () => {
    let user = await AuthHelper.getUserFromIdToken();
    try {
      const res = await fetch(
        `${ServerConfig.AWS.Serverless.API_BASE_URL_2}/centri/settings/${user.Username}`
      );
      const json = await res.json();
      if (json) setCentro({ ...json });
    } catch (ex) {
      console.log(ex);
      alert("Errore server");
    }
  };

  const saveSchool = async () => {
    setLoading(true);
    let user = await AuthHelper.getUserFromIdToken();
    try {
      await fetch(
        `${ServerConfig.AWS.Serverless.API_BASE_URL_2}/centri/settings/${user.Username}`,
        {
          method: "PUT",
          body: JSON.stringify({
            ...centro,
            color: centro.color.hex ? centro.color.hex : centro.color,
          }),
        }
      );
      alert("Impostazioni salvate con successo");
    } catch (ex) {
      console.log(ex);
      alert("Errore server");
    } finally {
      setLoading(false);
    }
  };

  const uploadToS3 = async (file, key) => {
    setLoading(true);
    config.update({
      Region: ServerConfig.AWS.s3Bucket.Region,
      credentials: {
        accessKeyId: ServerConfig.AWS.s3Bucket.AccessKeyId,
        secretAccessKey: ServerConfig.AWS.s3Bucket.SecretKeyId,
      },
    });

    const s3 = new S3({
      apiVersion: ServerConfig.AWS.s3Bucket.ApiVersion,
      credentials: {
        accessKeyId: ServerConfig.AWS.s3Bucket.AccessKeyId,
        secretAccessKey: ServerConfig.AWS.s3Bucket.SecretKeyId,
      },
    });

    try {
      const fileBase64 = await fileConverterBase64(file);
      const fileParticles = fileBase64.split(",")[0];
      const fileName = `${dayjs().valueOf()}.document-file.${
        fileParticles.split(";")[0].split("/")[1]
      }`;

      const params = {
        Bucket: ServerConfig.AWS.s3Bucket.BucketName,
        Key: fileName,
        Body: Buffer.from(fileBase64.split(",")[1], "base64"),
        ContentType: file.type,
        ACL: "public-read",
      };

      await s3.putObject(params).promise();
      setCentro({
        ...centro,
        [key]: `${ServerConfig.AWS.S3.URL}/${fileName}`,
      });
    } catch (ex) {
      console.log(ex);
      alert("Errore durante il caricamento del file");
    } finally {
      setLoading(false);
    }
  };

  const ImageDropzone = ({ title, fieldKey, imageUrl }) => (
    <Grid xs={12} sx={{ textAlign: "left", mb: 3 }}>
      <h2>{title}</h2>
      <Dropzone onDrop={(acceptedFiles) => uploadToS3(acceptedFiles[0], fieldKey)}>
        {({ getRootProps, getInputProps }) => (
          <section
            style={{
              width: "100%",
              padding: 40,
              border: "1px solid #000",
              borderRadius: 12,
              textAlign: "center",
              backgroundColor: "#fafafa",
              position: "relative",
            }}
          >
            <div {...getRootProps()} style={{ cursor: "pointer", position: "relative" }}>
              <input {...getInputProps()} />
              {!imageUrl && (
                <p style={{ marginBottom: 16 }}>
                  Trascina o clicca per caricare un’immagine
                </p>
              )}
              {imageUrl && (
                <div style={{ position: "relative", display: "inline-block" }}>
                  <img
                    src={imageUrl}
                    alt={title}
                    style={{
                      width: "100%",
                      maxWidth: 600,
                      height: "auto",
                      borderRadius: 8,
                      border: "1px solid #ddd",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                      transition: "all 0.3s ease",
                      opacity: 1,
                    }}
                    className="hoverable-image"
                  />
                  {/* overlay visibile al passaggio */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0,0,0,0.4)",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 8,
                      opacity: 0,
                      transition: "opacity 0.3s",
                    }}
                    className="hover-overlay"
                  >
                    <p style={{ fontSize: 18, fontWeight: 500 }}>
                      Clicca per cambiare
                    </p>
                  </div>
                </div>
              )}
            </div>
          </section>
        )}
      </Dropzone>
    </Grid>
  );

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container sx={{ mt: 6 }}>
        <Grid container spacing={2}>
          {/* LOGO TOP */}
          <ImageDropzone
            title="Logo Top"
            fieldKey="logo_top"
            imageUrl={centro.logo_top}
          />

          {/* IMMAGINE IN BASSO */}
          <ImageDropzone
            title="Immagine in basso"
            fieldKey="image_bottom"
            imageUrl={centro.image_bottom}
          />

          {/* COLORE PRIMARIO */}
          <Grid xs={3} sx={{ mr: 12, mb: 3 }}>
            <h2 style={{ textAlign: "left" }}>Colore primario</h2>
            <SketchPicker
              color={
                typeof centro.color === "string"
                  ? { hex: centro.color }
                  : centro.color || { hex: "#000000" }
              }
              onChange={(color) => setCentro({ ...centro, color })}
            />
          </Grid>

          {/* INTESTAZIONE CAPITANERIA */}
          <Grid xs={3} sx={{ mr: 12, mb: 3 }}>
            <h2 style={{ textAlign: "left" }}>Intestazione capitaneria</h2>
            <TextField
              multiline
              minRows={4}
              fullWidth
              value={centro.capitaneria || ""}
              onChange={(e) =>
                setCentro({ ...centro, capitaneria: e.target.value })
              }
            />
          </Grid>

          {/* BOTTONE SALVA */}
          <Grid xs={10}></Grid>
          <Grid xs={2} sx={{ mt: 3 }}>
            <LoadingButton
              loading={loading}
              fullWidth
              variant="contained"
              onClick={() => saveSchool()}
            >
              Salva dati
            </LoadingButton>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Settings;
